import React from 'react';
import { updateTcOrder } from 'actions/tc/orders';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AutoComplete from 'material-ui/AutoComplete';
import _ from 'lodash';
import api from 'services';

import { calculateIsIfchorBroker } from 'helpers/realCompanies';

const accountsConfig = {
    text: 'name', 
    value: '_id'
};

class Account extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accounts: [],
            companies: [],
        };

        this.dAutocomplete = _.debounce((searchText) => {
            if (searchText.length <= 2) {
                return;
            }

            const withRealCompanies = calculateIsIfchorBroker(this.props.context.userId.email);

            api.findCompany(searchText, withRealCompanies)
                .then((response) => {
                    const accounts = response.data.data.map(company => ({
                        name: company.name,
                        _id: company._id,
                        item: company,
                    }));

                    this.setState({
                        accounts,
                    });

                })
                .catch(() => null);
        }, 1000);
    }

    onChangeAutoCompleteAccount = searchText => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder.account = {
            name: searchText,
        };

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);

        this.dAutocomplete(searchText);
    }

    onChooseAutoCompleteAccount = (updateProperties) => {
        if (!updateProperties) {
            return;
        }

        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder.account = {
            _id: updateProperties.item._id,
            name: updateProperties.name,
        };

        this.setState({
            accounts: [],
        });
        
        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    render() {
        const { accounts } = this.state;
        const { account } = this.props.tcOrder;
        
        return (
            <div className='row'>
                <div className='col-xs-6'>
                    <AutoComplete
                        name='account'
                        floatingLabelText='Account'
                        textFieldStyle={{ fontSize: '13px' }}
                        hintText='Account'
                        searchText={(account && account.name) || ''}
                        dataSource={accounts}
                        onUpdateInput={this.onChangeAutoCompleteAccount}
                        onNewRequest={this.onChooseAutoCompleteAccount}    
                        dataSourceConfig={accountsConfig}
                        filter={AutoComplete.noFilter}
                        listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
                        menuStyle={{ width: 'auto' }}
                        popoverProps={{
                            canAutoPosition: true,
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default connect(
    ({ tcOrders: { items: tcOrders }, letter: { context } }, ownProps) => {
        return {
            tcOrders,
            tcOrder: tcOrders[ownProps.numberOrderTable],
            context,
        };
    },
    dispatch => bindActionCreators({
        updateTcOrder,
    }, dispatch),
)(Account);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/content/Account.jsx